// extracted by mini-css-extract-plugin
module.exports = {"who-container":"Who_who-container__1Oglf","who":"Who_who__1gDB9","item":"Who_item__21uw1","img-container":"Who_img-container__2TvMf","more":"Who_more__3JiKq"};